import { createVariables } from "./createVariables.js";
function createTokens(tokens2) {
  return createVariables(tokens2);
}
const tokens = createTokens({
  size: { 0: 1 },
  space: { 0: 1 },
  radius: { 0: 1 },
  zIndex: { 0: 1 },
  color: { 0: "hi" }
});
export {
  createTokens
};
//# sourceMappingURL=createTokens.js.map
